import {
    EPaymentProviderResponse,
    IPaymentProviderResponse,
    TIsNewPaymentProvider,
} from "@features/Payment/interface/IPaymentProvider";

export const getResponseToState = (response: IPaymentProviderResponse): TIsNewPaymentProvider =>
    response.paymentProvider === EPaymentProviderResponse.STANCER;
